export const STUDIO = {
  name: 'OnyxUp',
  founder: 'Halil Yılmaz',
  email: 'info@onyxup.net',
  developerUrl: 'https://apps.apple.com/tr/developer/halil-ylmaz/id1831747268',
  social: {
    linkedin: 'https://www.linkedin.com/company/109376197/',
    medium: 'https://medium.com/@haliilylmaaz',
    github: 'https://github.com/OnyxUP',
    x: 'https://x.com/Onyxup9',
  },
};
